/**
 * Dev: call FastAPI directly unless REACT_APP_BACKEND_URL is set (matches frontend/.env.example).
 * CORS on the server allows localhost + 127.0.0.1 dev origins.
 */
import { DEV_BACKEND_BASE_URL } from '../config/devBackendUrl';

const isDev = process.env.NODE_ENV === 'development';
const envBackend = (process.env.REACT_APP_BACKEND_URL || '').trim();

function devBackendBase() {
  if (envBackend) {
    return envBackend.replace(/\/$/, '');
  }
  return DEV_BACKEND_BASE_URL;
}

export function getBackendBaseUrl() {
  if (isDev) {
    return devBackendBase();
  }
  // Production: REACT_APP_BACKEND_URL is baked at build time (set it on Render for the static site).
  if (!envBackend) {
    // eslint-disable-next-line no-console
    console.error(
      '[MyLegacyBridge] Production build is missing REACT_APP_BACKEND_URL. ' +
        'Set it in your static host (e.g. Render) to your API origin, e.g. https://your-api.onrender.com — then rebuild.'
    );
    return '';
  }
  return envBackend.replace(/\/$/, '');
}

export function getApiBase() {
  const base = getBackendBaseUrl().replace(/\/$/, '');
  return `${base}/api`;
}
